import { Button, Flex, Text, Tooltip } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { FiEye } from 'react-icons/fi';

import { AdminMasterClassListViewQuery } from '@/@generated/codegen/API';
import { AdminManageMasterClassMenu } from '@/components/AdminManageMasterClassMenu/AdminManageMasterClassMenu';
import ClientTag from '@/components/ClientTag/ClientTag';

export type AdminMasterClassListItemType =
  AdminMasterClassListViewQuery['listMasterClasses']['edges'][number]['node'];

const columnHelper = createColumnHelper<AdminMasterClassListItemType>();

type Props = {
  t: TFunction<'translation', undefined, 'translation'>;
  onAccessLinkClick: (masterClass: AdminMasterClassListItemType) => void;
  // onViewCaseClick: (el: UnloadedPatientCaseFieldsFragment) => void;
  onPreviewClick: (id: string) => void;
};

const getColumns = ({ t, onAccessLinkClick, onPreviewClick }: Props) => {
  const columns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (props) => <Text>{props.getValue()}</Text>,
    }),

    columnHelper.accessor('title', {
      header: 'Title',
      cell: (props) => (
        <Flex direction="column" gap={2}>
          <Tooltip label={props.getValue()}>
            <Text fontSize="lg">{props.getValue()}</Text>
          </Tooltip>
          <Flex w="full" justifyContent="left" gap={2}>
            <AdminManageMasterClassMenu masterClass={props.row.original} />
          </Flex>
        </Flex>
      ),
    }),

    columnHelper.accessor('clients', {
      id: 'clients',
      enableSorting: false,
      header: 'Client',
      // filterFn: createArrayFilterFn<Client>('clientName'),
      cell: (props) => {
        const clientList = props.row.original.clients.edges.map((el) => el.node);
        return (
          <Flex flexDir="row" gap={2} flexWrap="wrap">
            {clientList.map((elem) => (
              <ClientTag key={elem.id} client={elem.name} />
            ))}
          </Flex>
        );
      },
    }),

    columnHelper.display({
      id: 'access links',
      header: 'Access Links',
      cell: (props) => {
        // const masterClassID = props.row.original.id;
        // const code = props.row.original.accessLink?.accessCode;
        // if (!code) return null;
        // return (
        //   <Flex alignItems="center" gap={2}>
        //     <Text>{code}</Text>
        //     <CopyButton text={getGuestUrl(masterClassID, code)} size="xs" />
        //   </Flex>
        // );
        return (
          <Button
            onClick={() => {
              onAccessLinkClick(props.row.original);
            }}
            size="sm"
          >
            Manage links
          </Button>
        );
      },
    }),
    columnHelper.display({
      id: 'preview',
      header: 'Preview',
      size: 400,
      cell: (props) => {
        const id = props.row.original.id;
        return (
          <Button onClick={() => onPreviewClick(id)} variant="secondary" size="sm" flexShrink={0}>
            <FiEye />
            <Text ml="5px">{t('common.preview')}</Text>
          </Button>
        );

        // const patientCases = props.row.original.patientCases.edges.map((el) => el.node);

        // return (
        //   <>
        //     {patientCases.map((el) => (
        //       <Flex key={el.id} alignItems="center" justifyContent="space-between" gap={4} w="100%">
        //         <Tooltip label={el.legacyCaseId} placement="top" hasArrow>
        //           <Text
        //             isTruncated
        //             maxW="calc(100% - 120px)" // leave space for button
        //           >
        //             - {el.legacyCaseId}
        //           </Text>
        //         </Tooltip>

        //         <Button
        //           onClick={() => onViewCaseClick(el)}
        //           variant="secondary"
        //           size="sm"
        //           flexShrink={0}
        //         >
        //           <FiEye />
        //           <Text ml="5px">{t('admin.cases.table.viewCase.button')}</Text>
        //         </Button>
        //       </Flex>
        //     ))}
        //   </>
        // );
      },
    }),
  ];

  return columns;
};

export default getColumns;
